<template>
	<el-card shadow="never" class="asset-planning-card">
		<div class="header-row" slot="header">
			<div class="title">
				<span style="margin-right: 10px">资产规划类型</span>
			</div>
			<div
				style="color: #409eff; font-size: 14px; cursor: pointer"
				@click="
					() => {
						this.$router.push('/pages/asset/assetPlan');
					}
				">
				更多
			</div>
		</div>
		<div class="content-row">
			<PieChart
				:categories="planningTypes"
				:option="{
					series: [
						{
							radius: ['65%', '85%'],
						},
					],
				}" />
		</div>
	</el-card>
</template>

<script>
	import { getHomeAssetStatusStats } from '@/api/home/homeApi.js';
	export default {
		name: 'AssetPlanningType',
		data() {
			return {
				planningTypes: [],
			};
		},
		mounted() {
			this.initChart();
		},

		methods: {
			async initChart() {
				try {
					const { data } = await getHomeAssetStatusStats();
					this.planningTypes = data.statuses || [];
				} catch (error) {
					console.error('ECharts init error:', error);
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		height: calc(100% - 38px);
	}

	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}
	.title {
		font-weight: bold;
	}

	.label {
		color: #e6a23c;
		font-weight: bold;
	}

	.content-row {
		width: 100%;
		height: 100%;
	}
	.chart-container {
		width: 100%;
		height: 100%;
	}
</style>
